import { useState } from 'react';
import { useCredits } from '@/hooks/useCredits';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Coins, Plus } from 'lucide-react';
import { DepositModal } from './deposit';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export function CreditBalance() {
  const { credits, isLoading } = useCredits();
  const [showDepositModal, setShowDepositModal] = useState(false);

  if (isLoading) {
    return (
      <div className="flex items-center gap-2">
        <Badge variant="secondary" className="gap-1 h-7 sm:h-8">
          <Coins className="h-3 w-3 animate-pulse-subtle" />
          <span className="text-xs animate-pulse">...</span>
        </Badge>
      </div>
    );
  }

  return (
    <>
      <div className="flex items-center">
        <Tooltip>
          <TooltipTrigger asChild>
            <Badge variant="secondary" className="gap-1 sm:gap-1.5 pr-0.5 sm:pr-1 h-7 sm:h-8 transition-all duration-200 hover:shadow-sm cursor-help">
              <Coins className="h-3 w-3 sm:h-3.5 sm:w-3.5 text-primary" />
              <span className="font-semibold text-xs sm:text-sm tabular-nums">{credits?.balance ?? 0}</span>
              <span className="text-muted-foreground text-[10px] sm:text-xs hidden xs:inline">credits</span>
              <Button
                variant="ghost"
                size="icon"
                className="h-5 w-5 sm:h-6 sm:w-6 ml-0.5 sm:ml-1 hover:bg-primary/20 transition-all duration-200 hover:scale-110 active:scale-95"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDepositModal(true);
                }}
                aria-label="Add credits"
              >
                <Plus className="h-3 w-3" aria-hidden="true" />
              </Button>
            </Badge>
          </TooltipTrigger>
          <TooltipContent className="max-w-[200px] text-center">
            <p className="text-sm">Credits unlock predictions. 1 credit = 1 prediction. Earn free credits daily!</p>
          </TooltipContent>
        </Tooltip>
      </div>

      <DepositModal open={showDepositModal} onOpenChange={setShowDepositModal} />
    </>
  );
}
